import { differenceInHours } from 'date-fns'

// Reload if the app was loaded more than 24 hours ago. This is to avoid the app becoming stale due to only doing client-side navigation.
export function shouldReloadApp(): boolean {
  return typeof window !== 'undefined'
    ? differenceInHours(new Date(), window.__APP_LOADED_AT__) > 24
    : false
}
